<template>
  <div class="input-field">
    <p class="body-title">{{title}}</p>
    <p class="note">{{ note }}</p>
    <p class="note default">{{ defaultValueNote }}</p>
    <p class="note default">{{ additionalNote }}</p>
    <input
      :type="inputType"
      :value="value"
      @input="triggerEvent"
      :disabled="disabled == 1"
      :placeholder="placeholder"
      v-on:keyup.enter="enterPressed"
      :class="{'disabled' : disabled == 1}"
    >
  </div>
</template>

<script>
export default {
  props: {
    defaultValueNote: String,
    additionalNote: String,
    placeholder: String,
    note: String,
    disabled: Number,
    title: String,
    value: String,
    isPassword: Boolean
  },
  computed: {
    inputType() {
      return this.isPassword ? "password" : "text";
    }
  },
  methods: {
    triggerEvent(event) {
      this.$emit("input", event.target.value);
    },
    enterPressed() {
      this.$emit("keyup");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/styles.scss";

input {
  box-sizing: border-box;
  padding: 0;
  padding-left: 20px;
  padding-right: 20px;
  margin: 0;
  margin-top: 15px;
  width: $input-field-width;
  height: $input-field-height;
  background: $light-grey-color;
  border: none;
  border-radius: 5px;
  color: white;

  box-shadow: none;
}

.note {
  width: $input-field-width;
  font-weight: 400;
  font-size: 11px;
}

.disabled {
  color: $dark-grey-color;
}
</style>
